// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownItem_wrapper_3VRc_","disabled":"DropdownItem_disabled_FEcrS"};